import { clsx } from 'clsx'
import { type FC } from 'react'

import { ProductPicture } from '../../product'

import erxIcon from './../../../public/images/erx-fallback-icon.svg'

import styles from './OrderImageItem.module.css'

type OrderImageItemProps = {
  alt: string
  className?: string
  'data-qa-id'?: string
  imageClassName?: string
  isERx?: boolean
  src: string | undefined
}

export const OrderImageItem: FC<OrderImageItemProps> = ({
  alt,
  className,
  'data-qa-id': dataQaId,
  imageClassName,
  isERx,
  src,
}) => {
  return (
    <div
      className={clsx(
        'relative size-16 shrink-0 grow-0 rounded-s bg-light-primary-medium',
        className,
        isERx && 'flex p-1',
      )}
      data-qa-id={dataQaId}
    >
      <ProductPicture
        fallbackSrc={isERx ? erxIcon.src : undefined}
        imageProps={{
          alt,
          className: clsx(
            'rounded-s',
            imageClassName,
            styles['order-image-item__image'],
          ),
          fill: true,
          src,
        }}
      />
    </div>
  )
}
